export default "__VITE_ASSET__C5yWA108__"